import { useNavigate } from "react-router-dom";
import { useAuthFlow } from "../shared/useAuthFlow";
import AuthShell from "../shared/AuthShell";
import AuthForm from "../shared/AuthForm";

function SignIn(): JSX.Element {
  const navigate = useNavigate();
  const flow = useAuthFlow({
    onAuthenticated: (role) => navigate(role === "ADMIN" ? "/orders" : "/"),
  });

  return (
    <AuthShell title={flow.title} subtitle={flow.subtitle} loading={flow.loading}>
      <AuthForm flow={flow} />
    </AuthShell>
  );
}

export default SignIn;
